// prompt-popup.js
document.addEventListener("DOMContentLoaded", () => {
  // Create the popup container
  const promptPopup = document.createElement("div");
  promptPopup.id = "pixar-prompt-popup";
  promptPopup.style.cssText = `
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, 0.98);
    z-index: 99999999;
    display: none;
    overflow: auto;
    padding: 20px;
    box-sizing: border-box;
    font-family: Helvetica, Arial, sans-serif;
  `;

  // Add the provided HTML content
  promptPopup.innerHTML = `
    <div style="position: relative; max-width: 700px; margin: 30px auto; padding: 30px; background: white; border-radius: 8px; box-shadow: 0 0 30px rgba(0,0,0,0.2); font-family: Helvetica, Arial, sans-serif;">
      <button id="prompt-close-button" style="position: absolute; top: 10px; right: 10px; background: none; border: none; font-size: 30px; cursor: pointer; padding: 5px; color: #555; font-family: Helvetica, Arial, sans-serif;">&times;</button>
      
      <h2 style="text-align: center; font-size: 28px; margin-bottom: 20px; font-weight: bold; font-family: Helvetica, Arial, sans-serif;">Describe Your Vision</h2>
      <p style="text-align: center; font-size: 16px; margin-bottom: 25px; color: #666; font-family: Helvetica, Arial, sans-serif;">Tell us how you want your image transformed</p>
      
      <div id="selected-image-preview" style="text-align: center; margin-bottom: 25px;">
        <img id="preview-image" src="" alt="Your selected image" style="max-width: 300px; max-height: 300px; border-radius: 8px; box-shadow: 0 4px 12px rgba(0,0,0,0.1);" />
      </div>
      
      <div id="prompt-text-container" style="margin: 0 auto 25px; max-width: 500px;">
        <label for="image-prompt" style="display: block; font-size: 16px; font-weight: bold; margin-bottom: 10px; color: #333; font-family: Helvetica, Arial, sans-serif;">
          Describe your desired transformation:
        </label>
        <textarea 
          id="image-prompt" 
          placeholder="E.g., 'Make it look like a vintage poster with dramatic lighting'"
          style="width: 100%; min-height: 100px; padding: 12px; font-size: 14px; border: 2px solid #ddd; border-radius: 8px; resize: vertical; font-family: Helvetica, Arial, sans-serif; box-sizing: border-box;"
          maxlength="500"
          rows="4"
        ></textarea>
        <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 8px;">
          <div style="font-size: 12px; color: #e74c3c; font-family: Helvetica, Arial, sans-serif;">
            <span id="prompt-error-message" style="display: none;"></span>
          </div>
          <div style="font-size: 12px; color: #666; font-family: Helvetica, Arial, sans-serif;">
            <span id="char-count">0/500</span>
          </div>
        </div>
      </div>
      
      <div style="display: flex; gap: 15px; justify-content: center;">
        <button id="prompt-back-button" style="background-color: #f0f0f0; color: #333; padding: 15px 30px; font-size: 16px; font-weight: bold; border: none; border-radius: 8px; cursor: pointer; font-family: Helvetica, Arial, sans-serif;">Back</button>
        <button id="prompt-continue-button" style="background-color: #1E316A; color: white; padding: 15px 30px; font-size: 16px; font-weight: bold; border: none; border-radius: 8px; cursor: pointer; font-family: Helvetica, Arial, sans-serif;" ${window.promptVisible && 'disabled'}>Continue</button>
      </div>
    </div>
  `;

  document.body.appendChild(promptPopup);

  let Base64ImageUrl = '';
  const previewImage = promptPopup.querySelector("#preview-image");
  const textContainer = promptPopup.querySelector("#prompt-text-container");
  const closeButton = promptPopup.querySelector("#prompt-close-button");
  const popupOpenButton = document.getElementById("aurora-upload-button");
  const backButton = promptPopup.querySelector("#prompt-back-button"); 
  const continueButton = promptPopup.querySelector("#prompt-continue-button"); 

  const textarea = promptPopup.querySelector("#image-prompt"); // your textarea
  const counter = promptPopup.querySelector("#char-count"); // place to show count
  const errorMsg = promptPopup.querySelector("#prompt-error-message"); // error display
  const maxLength = 500; // set your limit
  const minLength = 10; // min required characters

  // Global function to show popup
  window.showPromptPopup = function (imageUrl) {
    // Skip prompt popup for single face swap template
    if (window.isSingleFaceSwap) {
      console.log('Single face swap detected - using dedicated flow');
      Base64ImageUrl = imageUrl;
      window.fluxPrompt = ''; // No prompt for single face swap
      window.customerPrompt = '';
      window.userPrompt = '';
      
      // For single face swap, we need to use the dedicated handler
      // Check if we have the processSingleFaceSwap function available
      if (typeof window.processSingleFaceSwap === 'function' && imageUrl instanceof File) {
        console.log('Using dedicated single face swap processor');
        window.processSingleFaceSwap(imageUrl, window.singleFaceSwapTargetBase64);
        return;
      }
      
      // Otherwise fall back to the unified API client with proper flags
      if (window.unifiedApiClient) {
        console.log('Using UnifiedApiClient for single face swap');
        // Ensure the flag is set
        window.isSingleFaceSwap = true;
        
        // Convert file to base64 if needed and process
        if (imageUrl instanceof File) {
          const reader = new FileReader();
          reader.onload = async (e) => {
            // The unified API client will detect isSingleFaceSwap flag
            const result = await window.unifiedApiClient.transform({
              sourceImage: imageUrl,
              watermark: {
                url: "https://cdn.shopify.com/s/files/1/0896/3434/1212/files/watermarklogo.png",
                width: 200,
                height: 200,
                spaceBetweenWatermarks: 100
              }
            });
            console.log('Single face swap result:', result);
          };
          reader.readAsDataURL(imageUrl);
          return;
        }
      }
      
      // Last resort - trigger the standard flow but with flags set
      if (typeof window.proceedWithTransformation === 'function') {
        window.proceedWithTransformation();
      }
      return;
    }
    
    previewImage.src = imageUrl || "";
    Base64ImageUrl = imageUrl;
    textContainer.style.display = window.promptVisible ? "block" : "none";
    promptPopup.style.display = "block";
    document.body.style.overflow = "hidden"; // lock scroll
  };

  // Global function to hide popup
  window.hidePromptPopup = function () {
    promptPopup.style.display = "none";
    document.body.style.overflow = ""; // restore scroll
  };

  // Close button listener
  closeButton.addEventListener("click", window.hidePromptPopup);


    // Back button inside promptPopup
  if (backButton) {
    backButton.addEventListener("click", function () {
      // Reopen upload popup
      popupOpenButton.click();
      window.hidePromptPopup();

      // Clear preview image
      if (previewImage) {
        previewImage.src = "";
      }
    });
  }

  textarea.setAttribute("maxlength", maxLength); // HTML safeguard

  textarea.addEventListener("input", function () {
    const currentLength = textarea.value.length;
    counter.textContent = `${currentLength}/${maxLength}`;

    // Show/hide error message based on length
    if (currentLength < minLength) {
      errorMsg.textContent = "Please enter at least 10 characters";
      errorMsg.style.display = "block";
      continueButton.disabled = true;
    } else {
      errorMsg.style.display = "none";
      continueButton.disabled = false;
    }

    // Optional: color change when close to limit
    if (currentLength >= maxLength) {
      counter.style.color = "red";
    } else if (currentLength >= maxLength - 10) {
      counter.style.color = "orange";
    } else {
      counter.style.color = "";
    }
  });
  

  continueButton.addEventListener("click", async function () {
    const promptText = window.promptVisible ? textarea?.value : `Create a cute 3D animated-style rendering of a dog character in the center-bottom of the image, leaving a large empty space above the dog. Use a Pixar or Disney-inspired style: glowing, polished fur; rounded shapes; soft edges; plush, lightly textured fur with smooth shading. The dog should be sitting symmetrically and centered, with its full body visible from head to paw, facing forward. The head should be neutral or slightly tilted, and the dog should gaze gently upward with large, expressive, glossy eyes. The expression should be friendly, innocent, and emotionally engaging. The dog should be in full focus and take up a significant portion of the width of the frame. The background must be a flat, solid blue color with no props, textures, or shadows — evoking a clean, modern, minimal studio. The lighting must be soft, uniform, and diffuse to give the fur a gentle glow. The upper fourth portion of the frame should be entirely empty, creating an uninterrupted empty space above the character. Keep this empty space above the dog, scrictly only one fourth of the height of the total image. Still the dog should take up a significant portion of the canvas, being in full focus. The overall style must be fully stylized and animated — not photorealistic.`;

    if (!Base64ImageUrl) {
     throw new Error("Image URL is not present");
    };

    try {
        window.showLoadingPopup();
        closeButton.click();
        if (textarea) {
          textarea.value = '';
        }
        if (previewImage) {
          previewImage.src = "";
        }
        const finalResult = await window.startPixarTransformation(Base64ImageUrl, promptText);
        window.hideLoadingPopup();
        if(window.resultImageUrl){
            if (window.textOverleyVisible) {
              window.showTextPopup(finalResult.watermarkedImageUrlToShow);
            } else{
              window.showResultPopup(finalResult.watermarkedImageUrlToShow)
            }
        }
    } catch (err) {
        console.error(err);
    }
  });
});
